// src/pages/UpdateTransactionStatusPage.js
import React, { useState, useEffect } from 'react';
import {
  Container, Typography, TextField, Button, MenuItem, Grid, Alert
} from '@mui/material';
import axios from '../api/axios';

const UpdateTransactionStatusPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [newStatus, setNewStatus] = useState('');
  const [message, setMessage] = useState(null);

  useEffect(() => {
    async function fetchUserTransactions() {
      try {
        const res = await axios.get('/transactions');
        setTransactions(res.data.transactions);
      } catch (err) {
        setMessage({ type: 'error', text: 'Error loading transactions.' });
      }
    }
    fetchUserTransactions();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setMessage({ type: 'success', text: `Transaction updated to "${newStatus}".` });
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.error || 'Update failed' });
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h5" sx={{ my: 3 }}>
        Update Transaction Status
      </Typography>
      {message && <Alert severity={message.type}>{message.text}</Alert>}
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="Select Transaction"
              select
              fullWidth
              value={selectedId}
              onChange={(e) => setSelectedId(e.target.value)}
            >
              {transactions.map(tx => (
                <MenuItem key={tx.id} value={tx.id}>
                  {`#${tx.id} | ${tx.sender_name} ➜ ${tx.receiver_name} | Status: ${tx.status}`}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="New Status"
              select
              fullWidth
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
            >
              <MenuItem value="paid">Paid</MenuItem>
              <MenuItem value="cancelled">Cancelled</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" disabled={!selectedId || !newStatus}>
              Update Status
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default UpdateTransactionStatusPage;
